export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedProps<T extends string> {
  value: T;
  options: SegmentedOption<T>[];
  onChange: (v: T) => void;
  small?: boolean;
}

export const Segmented = <T extends string>({
  value, options, onChange, small,
}: SegmentedProps<T>) => (
  <div className={`seg${small ? " small" : ""}`}>
    {options.map((opt) => (
      <button
        key={opt.value}
        type="button"
        className={`seg-btn${opt.value === value ? " active" : ""}`}
        onClick={() => onChange(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </div>
);
